import styled from '@emotion/styled';

export const App = styled('div')`
  text-align: center;
`;

export const AppHeader = styled('header')`
  margin: 0 auto;
  max-width: 50%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
